import React from "react";
import clsx from "clsx";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { ReactComponent as EventIcon } from "assets/icons/events.svg";
import { Scrollbars } from "react-custom-scrollbars";
import NoData from "components/NoData";
import { useHistory } from "react-router-dom";

function truncate(source) {
  return source.length > 150 ? source.slice(0, 150 - 1) + "…" : source;
}

export default function UpcomingEvents(props) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Card className={clsx(classes.card, "Events")}>
      <CardHeader
        className={classes.cardHeader}
        classes={{
          title: "Events",
        }}
        title="Upcoming Events"
        avatar={<EventIcon />}
      />
      <CardContent className={classes.cardContent}>
        <Scrollbars
          renderTrackVertical={({ style, ...props }) => (
            <div
              {...props}
              className={classes.scrollTrackVertical}
              style={{
                ...style,
                backgroundColor: "#E2E2E2",
                height: "220px",
                right: "0px",
                bottom: "0px",
                top: "0px",
                borderRadius: "4px",
                width: "5px",
              }}
            />
          )}
          renderThumbVertical={({ style, ...props }) => (
            <div
              {...props}
              className={classes.scrollThumbVertical}
              style={{
                ...style,
                width: "5px",
                borderRadius: "4px",
                backgroundColor: "#05C1FF",
                height: "220px !important",
              }}
            />
          )}
        >
          {props.eventData.length > 0 ? (
            props.eventData.map((event) => (
              <Grid
                container
                className={classes.eventContainer}
              >
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <img alt="event" src={event.image} className={classes.eventImage} />
                </Grid>
                <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                  <Grid container className={classes.newsContainer}>
                    <Grid item xs={12} sm={12}>
                      <div 
                        className={classes.newsHeading} 
                        onClick={() => {
                          history.push("/event/detail/" + event.id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {event.title}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <div className={classes.newsContent} dangerouslySetInnerHTML={{ __html: truncate(event.description)}} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ))
          ) : (
            <>
              <NoData showImage errorText="No Upcoming Events" width={120} noMarginTop/>
            </>
          )}
        </Scrollbars>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: "0px 2px 10px #E5E9F2",
    borderRadius: 5,
    border: "1px solid #E6EAEE",
  },
  cardHeader: {
    padding: theme.spacing(2, 3, 0, 3),
  },
  eventContainer: {
    "@media (max-width: 600px)": {
      width: "90%",
    },
  },
  newsContainer: {
    width: "95%",

    "@media (max-width: 600px)": {
      marginTop: "10px",
    },

    "@media (min-width: 600px)": {
      marginTop: "10px",
    },

    "@media (min-width: 960px)": {
      marginLeft: "10px",
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  cardContent: {
    paddingTop: 11,
    height: 220,
  },
  settingIcon: {
    width: 20,
    height: 20,
  },
  eventImage: {
    borderRadius: 4,
    width: "124",
    height: "73",
    objectFit: "cover",
    "@media (max-width: 600px)": {
      marginTop: 20,
      width: "100%",
      height: "120px",
    },

    "@media (min-width: 600px)": {
      marginTop: 10,
      width: "100%",
      height: "120px",
    },
  },
  newsHeading: {
    fontFamily: "Poppins, Nova",
    fontWeight: "800 !important",
    fontSize: "14px !important",
    lineHeight: "19px !important",
    color: "#05c1ff !important",
    mixBlendMode: "normal",
    paddingBottom: "10px !important",
  },
  newsContent: {
    fontFamily: "Poppins, Nova",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#6c757d",
    mixBlendMode: "normal",
    paddingBottom: "10px !important",
  },
}));
